export default __webpack_public_path__ + "static/media/onboarding_checkbox.c17b7e17.png";